export default "__VITE_ASSET__hlnlEfDj__"